import { render, staticRenderFns } from "./DeleteSignature.vue?vue&type=template&id=1cf8b2e8"
import script from "./DeleteSignature.vue?vue&type=script&lang=js"
export * from "./DeleteSignature.vue?vue&type=script&lang=js"
import style0 from "./DeleteSignature.vue?vue&type=style&index=0&id=1cf8b2e8&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports